import { render, staticRenderFns } from "./StuffedItem.vue?vue&type=template&id=0f870645&scoped=true&"
import script from "./StuffedItem.vue?vue&type=script&lang=js&"
export * from "./StuffedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f870645",
  null
  
)

export default component.exports